module.exports = __webpack_public_path__ + "static/media/portfolio_management.67a076d1.png";